package org.molap.index

class EmptyUniqueIndex : AbstractUniqueIndex<Any?>() {
    override fun getAddress(key: Any?): Int {
        return 0
    }

    override fun head(count: Int): UniqueIndex<Any?> {
        return this
    }

    override fun tail(count: Int): UniqueIndex<Any?> {
        return this
    }

    override fun keepAddresses(addresses: IntArray): UniqueIndex<Any?> {
        return this
    }

    override fun contains(key: Any?): Boolean {
        return false
    }

    override fun getKey(i: Int): Any? {
        return null
    }

    override val size: Int
        get() = 0

    companion object {
        val instance: EmptyUniqueIndex = EmptyUniqueIndex()
    }
}
